module.exports = __webpack_public_path__ + "static/img/beta_bg_white_02.0ed6402c.svg";